"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertingOrder = void 0;
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const Assignation_1 = require("./Assignation");
const Order_1 = require("./Order");
const Passenger_1 = require("./Passenger");
const Payment_1 = require("./Payment");
let ConvertingOrder = class ConvertingOrder {
    _id = (0, uuid_1.v4)();
    received;
    confirmed;
    confirmedCar;
    driver;
    reminder;
    email;
    name;
    passengers;
    date;
    time = "9:00";
    from;
    to;
    via;
    eur;
    discount;
    status;
    followUp;
    internalNotes;
    notesForDriver;
    address;
    comments;
    orderId;
    isConverted = false;
    parsedPassengers;
    order;
    assignation;
    payment;
};
exports.ConvertingOrder = ConvertingOrder;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "_id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "received", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "confirmed", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "confirmedCar", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "driver", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "reminder", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "email", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "passengers", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "date", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "time", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "from", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "to", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "via", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "eur", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "discount", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "status", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "followUp", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "internalNotes", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "notesForDriver", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "address", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "comments", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ConvertingOrder.prototype, "orderId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ConvertingOrder.prototype, "isConverted", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Passenger_1.Passenger),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", Array)
], ConvertingOrder.prototype, "parsedPassengers", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Order_1.Order),
    __metadata("design:type", Order_1.Order)
], ConvertingOrder.prototype, "order", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Assignation_1.Assignation),
    __metadata("design:type", Assignation_1.Assignation)
], ConvertingOrder.prototype, "assignation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Payment_1.Payment),
    __metadata("design:type", Payment_1.Payment)
], ConvertingOrder.prototype, "payment", void 0);
exports.ConvertingOrder = ConvertingOrder = __decorate([
    (0, class_transformer_1.Exclude)()
], ConvertingOrder);
//# sourceMappingURL=ConvertingOrder.js.map